/* Rima Atelier · welcome offer popup
   Progressive enhancement. The markup ships hidden, so with no JS nothing shows.

   - Appears once per browser session, after the delay set in the theme editor.
   - Closing it, or following its button, hides it for good for that code. The
     dismissal is keyed to the code, so a new offer is shown again to everyone.
   - In the theme editor it shows at once and ignores both, so it can be styled. */
(function () {
  var DISMISSED = 'rima.promo.dismissed';
  var SEEN = 'rima.promo.seen';

  function read(storeName, key) {
    try {
      return window[storeName].getItem(key);
    } catch (e) {
      return null;
    }
  }

  function write(storeName, key, value) {
    try {
      window[storeName].setItem(key, value);
    } catch (e) {
      /* private mode or blocked storage: the popup simply shows again */
    }
  }

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function copyText(text) {
    function fallback() {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      var ok = false;
      try {
        ok = document.execCommand('copy');
      } catch (e) {
        ok = false;
      }
      document.body.removeChild(ta);
      return ok;
    }
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text).then(
        function () {
          return true;
        },
        function () {
          return fallback();
        }
      );
    }
    return Promise.resolve(fallback());
  }

  function init(el) {
    if (!el || el.dataset.rimaPromoReady) return;
    el.dataset.rimaPromoReady = '1';

    var code = el.getAttribute('data-code') || '';
    var design = el.hasAttribute('data-design-mode');
    var delay = parseInt(el.getAttribute('data-delay'), 10);
    if (isNaN(delay) || delay < 0) delay = 4;

    if (!design) {
      if (read('localStorage', DISMISSED) === code) return;
      if (read('sessionStorage', SEEN) === code) return;
    }

    var closeBtn = el.querySelector('[data-rima-promo-close]');
    var copyBtn = el.querySelector('[data-rima-promo-copy]');
    var copyLabel = el.querySelector('[data-rima-promo-copy-label]');
    var status = el.querySelector('[data-rima-promo-status]');
    var cta = el.querySelector('[data-rima-promo-cta]');
    var copyTimer = null;

    function show() {
      el.hidden = false;
      if (!design) write('sessionStorage', SEEN, code);
      /* two frames, so the transition runs from the hidden state */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          el.classList.add('is-open');
        });
      });
    }

    function dismiss() {
      var hadFocus = el.contains(document.activeElement);
      if (!design) write('localStorage', DISMISSED, code);
      el.classList.remove('is-open');
      window.setTimeout(
        function () {
          el.hidden = true;
        },
        reducedMotion() ? 0 : 400
      );
      /* do not strand keyboard focus on a node that is about to disappear */
      if (hadFocus) {
        var main = document.getElementById('MainContent');
        if (main) main.focus({ preventScroll: true });
      }
    }

    if (closeBtn) closeBtn.addEventListener('click', dismiss);

    el.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') dismiss();
    });

    if (cta) {
      cta.addEventListener('click', function () {
        if (!design) write('localStorage', DISMISSED, code);
      });
    }

    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        copyText(code).then(function (ok) {
          if (!ok) {
            if (status) status.textContent = 'Copy did not work, the code is ' + code;
            return;
          }
          copyBtn.classList.add('is-copied');
          if (copyLabel) copyLabel.textContent = 'Copied';
          if (status) status.textContent = 'Code ' + code + ' copied';
          window.clearTimeout(copyTimer);
          copyTimer = window.setTimeout(function () {
            copyBtn.classList.remove('is-copied');
            if (copyLabel) copyLabel.textContent = 'Copy';
            if (status) status.textContent = '';
          }, 2400);
        });
      });
    }

    if (design) {
      show();
    } else {
      window.setTimeout(show, delay * 1000);
    }
  }

  init(document.querySelector('[data-rima-promo]'));

  /* theme editor re-renders the section on every setting change */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target.querySelector('[data-rima-promo]'));
  });
})();
